module.exports = __webpack_public_path__ + "img/kodachrome.69ef2486.png";